// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4f199960","239":"448d64c2","251":"ec4f06cc","430":"e7c1676a","455":"d32994de","488":"dde91bcc","725":"6d3f2ccb"}[chunkId] + ".chunk.js";
};